const chartHasMoreThanOne = (chartData: any[]) => {
    let valuesGreatherThanZero = 0;

    chartData.forEach(data => {
        if(data.value > 0) valuesGreatherThanZero++;
    })

    return valuesGreatherThanZero > 1
}

export {
    chartHasMoreThanOne
}